import { render, staticRenderFns } from "./ParcelsTree.vue?vue&type=template&id=3cbeb781&"
import script from "./ParcelsTree.vue?vue&type=script&lang=js&"
export * from "./ParcelsTree.vue?vue&type=script&lang=js&"
import style0 from "./ParcelsTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports